import React from 'react';

const MultiRowConveyorBelt = ({ height, imagePath, imageWidth, speed, info, title, rows }) => {
  const tileHeight = Math.max(1, Math.round(height));
  const tileWidthPx = Math.max(1, Math.round(imageWidth));
  const totalHeight = tileHeight * (rows || 1);

  return (
    <div className="belt-container" title={title} style={{ height: totalHeight }}>
      <div className="multi-belt-shell" style={{ height: totalHeight }}>
        <div className="multi-belt-stack">
          {Array.from({ length: rows }, (_, i) => (
            <div
              key={i}
              className="multi-belt-row"
              style={{
                height: `${tileHeight}px`
              }}
            >
              <div
                className="belt-track-wrapper"
                style={{
                  height: `${tileHeight}px`,
                }}
              >
                <div
                  className="belt-track"
                  style={{
                    backgroundImage: `url(${imagePath})`,
                    backgroundSize: `${tileWidthPx}px ${tileHeight}px`,
                    backgroundRepeat: 'repeat',
                    '--tile-width': `${tileWidthPx}px`,
                    '--speed': `${speed}s`,
                    animationDelay: `-${(speed * i / rows)}s`
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      {info && (
        <div className="belt-info-wrapper">
          <div className="belt-info">{info}</div>
        </div>
      )}
    </div>
  );
};

export default MultiRowConveyorBelt;
